import { createSelector } from "reselect";
import { StoreState } from "Store/Reducers";

const fetchFiles = ({modules}: StoreState) => modules.files;
export const isFileUploading = createSelector(fetchFiles, ({ _isUploading }) => _isUploading);

export const getFilesByEntityId = createSelector(
    fetchFiles, 
    (_, entity_id) => entity_id,
    ({byEntityId}, entity_id) => byEntityId?.[entity_id]
);

export const getFilesByIdAsObject = createSelector(
    fetchFiles,
    (_, id) => id,
    ({ entities }, id) => entities?.[id]
);